import { render, staticRenderFns } from "./homework-container.vue?vue&type=template&id=03e01780&scoped=true"
import script from "./homework-container.vue?vue&type=script&lang=js"
export * from "./homework-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e01780",
  null
  
)

export default component.exports